<div class="card title-card mb-4">
  <div class="flex align-items-center">
    <i class="pi mr-1 title-card-icon" [class.pi-plus-circle]="mode === 'create'" [class.pi-pencil]="mode === 'edit'"></i>
    <p class="mb-0 text-3xl title">
      {{(mode == 'create' ? 'misc.creation.decoder' : 'misc.edition.decoder') | transloco | capitalize}}
    </p>
  </div>
</div>
<div class="card step-card flex flex-column">
  <form [formGroup]="decoderForm" *ngIf="decoderForm">
    <div class="grid">

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="name">{{'attribute.name' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <p-autoComplete
            id="name"
            type="text"
            formControlName="name"
            class="p-fluid"
            [suggestions]="filteredScriptsNames"
            (completeMethod)="searchScript($event)"
          ></p-autoComplete>
        </div>
        <app-validation-errors [control]="decoderForm.get('name')"></app-validation-errors>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="type">{{'attribute.type' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <p-dropdown
            [placeholder]="'select.type' | transloco"
            [options]="types"
            (onChange)="typeChanged($event)"
            styleClass="w-full"
            id="type"
            formControlName="type"
          ></p-dropdown>
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="routingKey">{{'attribute.routingKey' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <input pInputText id="routingKey" type="text" formControlName="routingKey" class="w-full">
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="tenant">{{'model.tenant' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <p-dropdown
            [placeholder]="'select.tenant' | transloco"
            [options]="tenants"
            [filter]="true"
            styleClass="w-full"
            id="tenant"
            optionLabel="name"
            formControlName="tenant"
          ></p-dropdown>
        </div>
      </div>

      <div class="col-12 md:col-12 xl:col-8" [hidden]="!sourceVisible">
        <div class="form-field col-12">
          <label for="source">{{'attribute.source' | transloco}}</label>
        </div>
        <pre id="source" class="col-12 m-0"><code
          [highlight]="decoderForm.get('source').value"
          [lineNumbers]="true"
        ></code></pre>
      </div>

    </div>
  </form>
  <div class="mt-auto">
    <div class="flex justify-content-between mt-4">
      <button
        [label]="'common.cancel' | transloco"
        [routerLink]="'/system/decoders'"
        pButton
        class="p-button-danger"
        iconPos="right"
      ></button>
      <p-button
        *ngIf="decoderForm"
        [label]="(mode == 'creation' ? 'common.create' : 'common.save') | transloco"
        [disabled]="!decoderForm.valid"
        [loading]="persistingChanges"
        (onClick)="persistDecoderData()"
        styleClass="p-button-primary"
        class="mr-2"
      ></p-button>
    </div>
  </div>
</div>
